import { useEffect, useState } from "react";
import "./App.css";
import { getFirestore, collection, getCountFromServer } from "firebase/firestore";
export const ActiveUsers = () => {

  const [tgUserid, setTgUserId] = useState(0);




  const db = getFirestore();

async function getTotalUsers() {
  const coll = collection(db, "telegram_users");
  const snapshot = await getCountFromServer(coll);
  console.log("Total users:", snapshot.data().count);
  //setUserCount(snapshot.data().count.toString().padStart(9, "0"));
  getUsers(snapshot.data().count);
}


const [usercount, setUserCount] = useState("000000");
const getUsers = (tgUsers) => {
  try {
    fetch("https://api.emorya.com/total-users")
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        var totalUsers = tgUsers + data.total_users;
        setUserCount(totalUsers.toString().padStart(9, "0"));
        //       setPhotos(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  } catch (e) {

    setUserCount(tgUsers.toString().padStart(9, "0"));

    console.log(e);
  }
};


  useEffect(() => {
    getTotalUsers()
  }, []);

  return (
    <>
      <div
       style={{
        padding:20,
        textAlign:'center',
        position:'relative'
        
       }}
        
      >

<div class="btn-shine" target="_blank" style={{
marginTop:-10
}}>{usercount}</div>
<br/>
<div style={{
    marginTop:10,
    fontWeight:'bold',
    fontSize:12
}}>
Total Active Users
</div>
        
      </div>
    </>
  );
};
